import { useState,useEffect,useCallback } from 'react';
import { BiUpArrowAlt } from 'react-icons/bi';
import Container from '../Container';
import Logo from '../navbar/Logo';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa6';

const socialMedia = [
    {
        id:1,
        title:"Facebook",
        icon:<FaFacebookF size={20}/>,
        link:"https://www.facebook.com/",
        target:"_self"
    },
    {
        id:2,
        title:"Twitter",
        icon:<FaTwitter size={20}/>,
        link:"https://www.twitter.com/",
        target:"_self"
    },
    {
        id:3,
        title:"Youtube",
        icon:<FaYoutube size={20}/>,
        link:"https://www.youtube.com/",
        target:"_self"
    },
    {
        id:4,
        title:"Instagram",
        icon:<FaInstagram size={20}/>,
        link:"https://www.instagram.com/",
        target:"_self"
    },
    {
        id:5,
        title:"LinkedinIn",
        icon:<FaLinkedinIn size={20}/>,
        link:"https://www.linkedinin.com/",
        target:"_self"
    },
];
const date = new Date();
const FooterBottom = () => {

    const [showTopBtn, setShowTopBtn] = useState(false);    

    const goToTop  = useCallback(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });        
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 800) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    return (
        <Container className="position-relative">
            <div className='row align-items-center justify-content-between'>
                <div className='col-12 col-lg-2 mb-4 mb-lg-0'>
                    <Logo />
                </div>
                <div className='col-12 col-lg-8'>
                    <div className='d-block d-md-flex align-items-center'>
                        <ul className='social-media d-inline-flex '>
                            {socialMedia && socialMedia.map(item =>
                                <li key={item.id}>
                                    <a href={item.link} target={item.target} title={item.title}>
                                        {item.icon}
                                    </a>
                                </li>
                            )}                    
                        </ul>

                        <div className='copy-right ms-0 ms-md-4 mt-2 mt-md-0'>
                            <p>&copy; {date.getFullYear()} enigmainfosystems. All Rights Reserved.</p>
                        </div>
                    </div>
                </div>            
            </div>
            {showTopBtn &&
                <div className='scoll-top d-flex align-items-center justify-content-center position-absolute' onClick={goToTop}>
                    <BiUpArrowAlt size={30} />
                </div>
            }           
        </Container>
    );
};

export default FooterBottom;